import React from 'react';

const COLORS = {
  'Solicitação recebida': 'bg-blue-100 text-blue-700',
  'Em análise': 'bg-sky-100 text-sky-700',
  'Aguardando sua aprovação': 'bg-amber-100 text-amber-800',
  'Agendada': 'bg-indigo-100 text-indigo-700',
  'Profissional definido': 'bg-violet-100 text-violet-700',
  'Em andamento': 'bg-yellow-100 text-yellow-800',
  'Concluída': 'bg-green-100 text-green-700',
  'Cancelada': 'bg-red-100 text-red-700',
  'Aguardando pagamento': 'bg-purple-100 text-purple-700',
};

const ParceiroStatusBadge = ({ status }) => (
  <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${COLORS[status] || 'bg-gray-100 text-gray-600'}`} data-testid="status-badge-parceiro">
    {status}
  </span>
);

export default ParceiroStatusBadge;
